import { TableColumnMeta } from "ds/components/Table/types";

export const WEBHOOKS_TABLE_STORAGE_KEY = "webhooksTableStorageKey";

export enum WEBHOOKS_COLUMN_ID {
  NAME = "NAME",
  LABELS = "LABELS",
  SPACE = "SPACE",
  STATUS = "STATUS",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const WEBHOOKS_TABLE_COLUMNS_CONFIG: Record<WEBHOOKS_COLUMN_ID, TableColumnMeta> = {
  [WEBHOOKS_COLUMN_ID.NAME]: {
    id: WEBHOOKS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [WEBHOOKS_COLUMN_ID.LABELS]: {
    id: WEBHOOKS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [WEBHOOKS_COLUMN_ID.SPACE]: {
    id: WEBHOOKS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [WEBHOOKS_COLUMN_ID.STATUS]: {
    id: WEBHOOKS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 112,
    defaultWidth: 140,
    maxWidth: 200,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [WEBHOOKS_COLUMN_ID.CREATED_AT]: {
    id: WEBHOOKS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: 240,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [WEBHOOKS_COLUMN_ID.DROPDOWN]: {
    id: WEBHOOKS_COLUMN_ID.DROPDOWN,
    title: "Webhook actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Partial<Record<WEBHOOKS_COLUMN_ID, string>> = {
  [WEBHOOKS_COLUMN_ID.NAME]: "name",
  [WEBHOOKS_COLUMN_ID.SPACE]: "space",
  [WEBHOOKS_COLUMN_ID.STATUS]: "enabled",
  [WEBHOOKS_COLUMN_ID.CREATED_AT]: "createdAt",
};
